export default "__VITE_ASSET__BEYcHMBv__"